.message {
  margin-top: 10px;
  color: #777;
}